<template>
  <l-form @submit="submit">
    <l-school-input
      v-model="model"
      class="flex-1 label:sr-only"
      allow-custom
      size="sm"
      v-bind="{ label, loading, placeholder }"
      @input="submit"
    />
    <l-button aria-label="Search" class="btn bg-transparent border-0 px-3" type="submit">
      <i class="fa-solid fa-magnifying-glass text-gray-500"/>
    </l-button>
  </l-form>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import LForm from "@/components/forms/LForm.vue"
import LSchoolInput from "@/components/inputs/LSchoolInput.vue"
import route from "ziggy-js"
import { ref } from "vue"

const model = defineModel("value", [Object, String])

defineProps({
  label: { type: String, default: "Search site" },
  placeholder: { type: String, default: "Search" },
})

const loading = ref(false)

const submit = () => {
  loading.value = true

  window.location.href = model.value?.url ?? route("search", { q: model.value })
}
</script>
